export interface IHistogeneticsCryoShipped{
    id: number,
    type: string,
    donorAlias: string,
    recipientAlias: string,
    shipBackDate: string
}
